import { decodeJwt } from 'jose/jwt/decode';
import { computed } from 'vue';

import { ACCESS_TOKEN_STORAGE_KEY } from '~/constants';
import env from '~/env';
import { INCENTIVE_ACTIVATION_ROLE } from '~/features/incentives/constants';
import localstorage from '~/foundation/storage/localstorage';
import { KeycloackApi } from '~/services/keycloack-api/keycloack-api.types';

/**
 * Fails closed (no one can activate) whenever the token is missing or decoding
 * fails — never throws.
 */
export default function useIncentiveActivationPermission() {
  const clientId = env.VITE_KEYCLOAK_CLIENT_ID;

  const canActivate = computed(() => {
    if (!clientId) return false;

    const token = localstorage.get<string>(ACCESS_TOKEN_STORAGE_KEY);
    if (!token) return false;

    try {
      const decoded = decodeJwt<KeycloackApi.JSONPayload>(token);
      // `resource_access` is typed with a fixed set of known clients; the incentive
      // activation client id is infra-provisioned and unknown at compile time, so it
      // has to be looked up dynamically.
      const resourceAccess = decoded.resource_access as unknown as
        Record<string, undefined | { roles: string[] }>;
      const roles = resourceAccess[clientId]?.roles ?? [];
      return roles.includes(INCENTIVE_ACTIVATION_ROLE);
    } catch {
      return false;
    }
  });

  return { canActivate };
}
